// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessInsightCard_bi__8frok {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: -moz-fit-content;
  height: fit-content;
}
.BusinessInsightCard_bi__title__18j5a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.BusinessInsightCard_bi__title_text__vLrS- {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
}
.BusinessInsightCard_bi__title_link__-8eIy {
  color: var(--color-fash-primary-3);
  text-decoration: underline;
  font-weight: 700;
}
.BusinessInsightCard_bi__content__vo9P6 {
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .BusinessInsightCard_bi__content__vo9P6 {
    grid-template-columns: repeat(2, 1fr);
  }
}
.BusinessInsightCard_bi__card__hsWCG {
  width: 100%;
  height: 10rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  padding: 0 1.5rem;
  border-radius: 1rem;
  cursor: pointer;
}
.BusinessInsightCard_bi__card__outline__MJBoY {
  border: 1px solid var(--color-fash-primary-3);
  transition: all 500ms;
}
.BusinessInsightCard_bi__card__outline__MJBoY:hover {
  color: var(--color-fash-primary-3);
  border: 1px solid var(--color-fash-primary-3);
}
.BusinessInsightCard_bi__card__title__8QiOt {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.BusinessInsightCard_bi__card__value__T0ZAJ {
  font-weight: 700;
  line-height: 2.2rem;
}
@media only screen and (max-width: 25em) {
  .BusinessInsightCard_bi__card__value__T0ZAJ {
    font-size: var(--default-font-small);
  }
}

.BusinessInsightCard_selectCurrency__ClWZk {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.BusinessInsightCard_selectCurrency__text__af-U\\+ {
  display: flex;
}
.BusinessInsightCard_selectCurrency__icon__olcPY {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-fash-primary-3);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.BusinessInsightCard_selectCurrency__icon__olcPY:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-fash-primary-3);
  transform: rotateZ(-180deg);
}
.BusinessInsightCard_selectCurrency__icon_active__73iZO {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.BusinessInsightCard_selectCurrency__list__zH6NI {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.BusinessInsightCard_selectCurrency__list_active__x6vbc {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.BusinessInsightCard_selectCurrency__list__zH6NI li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.BusinessInsightCard_selectCurrency__list__zH6NI li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/BusinessInsightCard.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EAAA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAGI;EACE,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;AADN;AAII;EACE,kCAAA;EACA,0BAAA;EACA,gBAAA;AAFN;AAME;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAJJ;AAMI;EARF;IASI,qCAAA;EAHJ;AACF;AAME;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;AAMI;EACE,6CAAA;EACA,qBAAA;AAJN;AAMM;EACE,kCAAA;EACA,6CAAA;AAJR;AAQI;EACE,oCAAA;EACA,mBAAA;AANN;AASI;EACE,gBAAA;EACA,mBAAA;AAPN;AASM;EAJF;IAKI,oCAAA;EANN;AACF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AARF;AAUE;EACE,aAAA;AARJ;AAWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AATJ;AAWI;EACE,4DACE;EAEF,6CAAA;EACA,2BAAA;AAXN;AAcI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACE;EAEF,wCAAA;EACA,2BAAA;AAdN;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACE;EAEF,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAlBJ;AAoBI;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAlBN;AAqBI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAnBN;AAqBM;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAnBR","sourcesContent":["@import \"../variables/breakpoints\";\n\n.bi {\n  width: 100%;\n  border-radius: 2rem;\n  background-color: var(--color-white);\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  padding: 3.5rem 2rem;\n  height: fit-content;\n\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n\n    &_text {\n      padding: 0;\n      margin: 0;\n      font-size: var(--default-font-size);\n      font-weight: 700;\n    }\n\n    &_link {\n      color: var(--color-fash-primary-3);\n      text-decoration: underline;\n      font-weight: 700;\n    }\n  }\n\n  &__content {\n    width: 100%;\n    display: grid;\n    box-sizing: border-box;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 1rem;\n\n    @media only screen and (max-width: $bp-1000) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  &__card {\n    width: 100%;\n    height: 10rem;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    justify-content: center;\n    padding: 0 1.5rem;\n    border-radius: 1rem;\n    cursor: pointer;\n\n    &__outline {\n      border: 1px solid var(--color-fash-primary-3);\n      transition: all 500ms;\n\n      &:hover {\n        color: var(--color-fash-primary-3);\n        border: 1px solid var(--color-fash-primary-3);\n      }\n    }\n\n    &__title {\n      font-size: var(--default-font-small);\n      line-height: 1.8rem;\n    }\n\n    &__value {\n      font-weight: 700;\n      line-height: 2.2rem;\n\n      @media only screen and (max-width: $bp-400) {\n        font-size: var(--default-font-small);\n      }\n    }\n  }\n}\n\n.selectCurrency {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--default-font-small);\n  position: relative;\n  margin-left: 2rem;\n\n  &__text {\n    display: flex;\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 3rem;\n    background-color: #f2f0f0;\n    color: var(--color-primary);\n    width: 5rem;\n    height: 5rem;\n    border-radius: 5rem;\n    border: solid 1px var(--color-fash-primary-3);\n    cursor: pointer;\n    transform: rotateZ(0);\n    transition-duration: 500ms;\n\n    &:hover {\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-fash-primary-3);\n      transform: rotateZ(-180deg);\n    }\n\n    &_active {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 3rem;\n      background-color: #f2f0f0;\n      color: var(--color-primary);\n      width: 5rem;\n      height: 5rem;\n      border-radius: 5rem;\n      border: solid 1px var(--color-primary-4);\n      cursor: pointer;\n      transition-duration: 500ms;\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    background-color: #f2f0f0;\n    color: var(--color-dark);\n    border-radius: 1rem;\n    box-shadow:\n      10px 10px 45px #bebebe,\n      -15px -15px 30px #ffffff;\n    position: absolute;\n    top: 6rem;\n    z-index: 30;\n    border: solid 1px var(--color-primary-4);\n\n    &_active {\n      background-color: var(--color-primary-7);\n      color: var(--color-primary);\n      font-weight: 700;\n    }\n\n    li {\n      list-style: none;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      border-radius: 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-primary-7);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi": `BusinessInsightCard_bi__8frok`,
	"bi__title": `BusinessInsightCard_bi__title__18j5a`,
	"bi__title_text": `BusinessInsightCard_bi__title_text__vLrS-`,
	"bi__title_link": `BusinessInsightCard_bi__title_link__-8eIy`,
	"bi__content": `BusinessInsightCard_bi__content__vo9P6`,
	"bi__card": `BusinessInsightCard_bi__card__hsWCG`,
	"bi__card__outline": `BusinessInsightCard_bi__card__outline__MJBoY`,
	"bi__card__title": `BusinessInsightCard_bi__card__title__8QiOt`,
	"bi__card__value": `BusinessInsightCard_bi__card__value__T0ZAJ`,
	"selectCurrency": `BusinessInsightCard_selectCurrency__ClWZk`,
	"selectCurrency__text": `BusinessInsightCard_selectCurrency__text__af-U+`,
	"selectCurrency__icon": `BusinessInsightCard_selectCurrency__icon__olcPY`,
	"selectCurrency__icon_active": `BusinessInsightCard_selectCurrency__icon_active__73iZO`,
	"selectCurrency__list": `BusinessInsightCard_selectCurrency__list__zH6NI`,
	"selectCurrency__list_active": `BusinessInsightCard_selectCurrency__list_active__x6vbc`
};
export default ___CSS_LOADER_EXPORT___;
